module.exports = flarum.core.compat['app'];